import { useEffect } from 'react';
import { useShortcutsStore, type ShortcutBinding } from '../store/shortcuts-store.js';

export interface UseShortcutOptions {
  description?: string;
  scope?: string;
}

export function useShortcut(chord: string, handler: (e: KeyboardEvent) => void, opts: UseShortcutOptions = {}): void {
  useEffect(() => {
    const register = useShortcutsStore.getState().register;
    return register({
      chord,
      handler,
      ...(opts.description !== undefined ? { description: opts.description } : {}),
      ...(opts.scope !== undefined ? { scope: opts.scope } : {})
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chord, opts.description, opts.scope]);
}

export function useShortcutsHelp(): ShortcutBinding[] {
  return useShortcutsStore((s) => s.bindings);
}
